/*
 * tbh-upgrades.js (2026-10-23, Sampath: "Build 1 to 7", from the international benchmark).
 * Three page behaviours, each a no-op where its markup is absent:
 *   1. the sticky buy bar on phones (snippets/tbh-sticky-buy.liquid);
 *   6. "Pairs well with" beside the button (snippets/tbh-pdp-alsoneed.liquid);
 *   4. (removed 2026-10-26: "Skip to products");
 *   the returns policy in a pop-up from the "7-day returns" link (snippets/tbh-pdp-assure.liquid);
 *   3b. the phone search row folds away on scroll down and returns on scroll up;
 *   desktop menu kept on one line, with whatever doesn't fit moved into "More".
 */

/* 1. STICKY BUY BAR (phones). It presses the page's own buy button, so variant, quantity and the
 * cart drawer are exactly the page's; it only mirrors what that button would do. */
(function () {
  var bar = document.querySelector('[data-tbh-sbar]');
  if (!bar) return;
  var btn = bar.querySelector('[data-tbh-sbar-btn]');
  var priceEl = bar.querySelector('[data-tbh-sbar-price]');
  var optsEl = bar.querySelector('[data-tbh-sbar-opts]');
  var root = document.documentElement;
  var MOBILE = window.matchMedia('(max-width: 768.98px)');

  function cta() {
    var info = document.querySelector('.cc-main-product .product-info');
    if (!info) return null;
    var c = info.querySelector('product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]');
    if (c && c.offsetParent) return c;
    var all = info.querySelectorAll('a, button');
    for (var i = 0; i < all.length; i++) {
      if (/contact us to order|order on whatsapp|add to cart|pre-?order/i.test(all[i].textContent) && all[i].offsetParent) return all[i];
    }
    return null;
  }
  var target = cta();
  if (!target) return;

  function sync() {
    var c = cta() || target;
    target = c;
    btn.textContent = (c.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
    btn.disabled = !!c.disabled;
    var p = document.querySelector('.cc-main-product .product-info .price__current .js-value') ||
            document.querySelector('.cc-main-product .product-info .price__current');
    var price = p ? p.textContent.replace(/\s+/g, ' ').replace(/^(Sale|Regular) price\s*/i, '').trim() : '';
    priceEl.textContent = price;
    var vals = [];
    document.querySelectorAll('.cc-main-product variant-picker input[type="radio"]:checked, .cc-main-product variant-picker select').forEach(function (el) {
      if (el.value) vals.push(el.value);
    });
    optsEl.textContent = vals.length ? vals.join(' · ') : '';
  }

  var ctaGone = false, footerIn = false, drawerOpen = false;
  function update() {
    var show = MOBILE.matches && ctaGone && !footerIn && !drawerOpen && !root.classList.contains('tbh-cf-open');
    if (show && bar.hidden) sync();
    bar.hidden = !show;
    root.classList.toggle('tbh-sbar-on', show);
  }

  /* Position check on scroll (timer-throttled), not IntersectionObserver or rAF: both can be paused
     in embedded and background views. The sticky header covers the top of the screen, so a button
     under it counts as gone; the footer in view hides the bar. */
  var foot = document.querySelector('.shopify-section-group-footer-group, footer');
  var ticking = false;
  function measure() {
    ticking = false;
    var head = document.querySelector('store-header');
    var hb = head ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
    var r = target.getBoundingClientRect();
    ctaGone = r.bottom < hb + 4;
    footerIn = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
    update();
  }
  function onScroll() { if (!ticking) { ticking = true; setTimeout(measure, 50); } }
  function watch() { measure(); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  measure();
  document.addEventListener('on:cart-drawer:after-open', function () { drawerOpen = true; update(); });
  document.addEventListener('on:cart-drawer:after-close', function () { drawerOpen = false; update(); });
  /* the theme may redraw the buy button on a variant change: watch the new one */
  document.addEventListener('on:variant:change', function () {
    setTimeout(function () { var c = cta(); if (c && c !== target) { target = c; watch(); } sync(); }, 120);
  });
  MOBILE.addEventListener ? MOBILE.addEventListener('change', update) : MOBILE.addListener(update);
  btn.addEventListener('click', function () { var c = cta() || target; if (c && !c.disabled) c.click(); });
})();

/* 6. PAIRS WELL WITH: three in-stock complementary products beside the button. Every tile has
 * "Add to cart" (Sampath, 2026-10-23): one variant adds at once; more than one opens a small picker
 * listing each variant with its price, and the chosen one is added. */
(function () {
  var box = document.querySelector('[data-tbh-also]');
  if (!box) return;
  var list = box.querySelector('[data-tbh-also-list]');
  var byId = {};
  function rupees(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }
  function img(src) {
    if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function addVariant(id, b) {
    b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        b.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        setTimeout(function () { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true })); }, 350);
      })
      .catch(function () { b.disabled = false; b.textContent = 'Add to cart'; });
  }
  var pick;
  function openPicker(p, b) {
    if (typeof HTMLDialogElement === 'undefined') { window.location.href = p.url; return; }
    if (!pick) {
      pick = document.createElement('dialog');
      pick.className = 'tbh-pop tbh-pop--pick';
      pick.innerHTML = '<div class="tbh-pop__head"><p class="tbh-pop__title"></p><button type="button" class="tbh-pop__close" aria-label="Close">&times;</button></div><div class="tbh-pop__body"><ul class="tbh-pick"></ul></div>';
      pick.querySelector('.tbh-pop__close').addEventListener('click', function () { pick.close(); });
      pick.addEventListener('click', function (e) { if (e.target === pick) pick.close(); });
      pick.addEventListener('close', function () { document.documentElement.classList.remove('tbh-pop-open'); });
      document.body.appendChild(pick);
    }
    pick.querySelector('.tbh-pop__title').textContent = p.title;
    pick.querySelector('.tbh-pick').innerHTML = p.variants.map(function (v) {
      return '<li><button type="button" class="tbh-pick__opt" data-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span>' + esc(v.title) + (v.available ? '' : ' <small class="tbh-pick__oos">Sold out</small>') + '</span><b>' + rupees(v.price) + '</b></button></li>';
    }).join('');
    pick.querySelector('.tbh-pick').onclick = function (e) {
      var o = e.target.closest('.tbh-pick__opt');
      if (!o || o.disabled) return;
      pick.close();
      addVariant(o.dataset.id, b);
    };
    document.documentElement.classList.add('tbh-pop-open');
    pick.showModal();
  }
  fetch(box.dataset.url + '.json?product_id=' + box.dataset.productId + '&intent=complementary&limit=8')
    .then(function (r) { return r.ok ? r.json() : { products: [] }; })
    .then(function (d) {
      var ps = (d.products || []).filter(function (p) { return p.available; }).slice(0, 3);
      if (!ps.length) return;
      list.innerHTML = ps.map(function (p) {
        byId[p.id] = p;
        return '<li class="tbh-also__item">' +
          '<a class="tbh-also__link" href="' + esc(p.url) + '">' +
            '<span class="tbh-also__img"><img src="' + esc(img(p.featured_image)) + '" alt="" width="160" height="160" loading="lazy"></span>' +
            '<span class="tbh-also__name">' + esc(p.title) + '</span><b class="tbh-also__price">' + rupees(p.price) + '</b></a>' +
          '<button type="button" class="tbh-also__add" data-pid="' + p.id + '">Add to cart</button></li>';
      }).join('');
      box.hidden = false;
      list.addEventListener('click', function (e) {
        var b = e.target.closest('.tbh-also__add');
        if (!b || b.disabled) return;
        var p = byId[b.dataset.pid];
        if (!p) return;
        var avail = p.variants.filter(function (v) { return v.available; });
        if (p.variants.length === 1 || avail.length === 1) addVariant(avail[0] ? avail[0].id : p.variants[0].id, b);
        else openPicker(p, b);
      });
    })
    .catch(function () {});
})();

/* 4. "Skip to products" was removed on 2026-10-26 (Sampath: "Skip to products look useless. Lets remove it"). */

/* RETURNS POLICY IN A POP-UP (Sampath, 2026-10-23: "open the page in popup instead of opening new
 * page"). Plain click on [data-tbh-returns] loads /policies/refund-policy once and shows its body in
 * a dialog; ctrl/cmd-click and no-JS still open the page itself. */
(function () {
  var dlg, body, cached;
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'tbh-pop';
    dlg.setAttribute('aria-labelledby', 'tbh-pop-title');
    dlg.innerHTML = '<div class="tbh-pop__head"><p class="tbh-pop__title" id="tbh-pop-title">Returns &amp; refunds</p>' +
      '<button type="button" class="tbh-pop__close" aria-label="Close">&times;</button></div>' +
      '<div class="tbh-pop__body"></div>';
    body = dlg.querySelector('.tbh-pop__body');
    dlg.querySelector('.tbh-pop__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('tbh-pop-open'); });
    document.body.appendChild(dlg);
  }
  function open(href) {
    if (!dlg) build();
    if (!cached) body.innerHTML = '<p class="tbh-pop__wait">Loading…</p>';
    document.documentElement.classList.add('tbh-pop-open');
    dlg.showModal();
    if (cached) return;
    fetch(href).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('.shopify-policy__body');
      if (!src) throw new Error('no policy body');
      cached = src.innerHTML;
      body.innerHTML = cached + '<p class="tbh-pop__more"><a href="' + href + '" target="_blank" rel="noopener">Open the full policy page</a></p>';
      body.scrollTop = 0;
    }).catch(function () { dlg.close(); window.location.href = href; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-tbh-returns]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || typeof HTMLDialogElement === 'undefined') return;
    e.preventDefault();
    open(a.getAttribute('href'));
  });
})();

/* 3b. SEARCH ROW ON PHONES: shown on the way up, folded on the way down (Sampath, 2026-10-23:
 * "similar to how the menu hides on the desktop"). The theme's own StoreHeader.handleScroll only
 * runs on desktop, so this mirrors its rules (open near the top, 5px of upward travel to reopen)
 * for phones. Never folds while the field has focus or a menu/drawer has fixed the page. */
(function () {
  var head = document.querySelector('store-header[data-is-sticky]');
  var row = head && head.querySelector('.header__search');
  if (!row) return;
  var MOBILE = window.matchMedia('(max-width: 768.98px)');
  var last = window.scrollY, ticking = false;
  /* The header is sticky, so folding the row would shorten the page by its height and move the
     scroll position, which reads as an upward scroll and unfolds it again: on phones the row
     flickered half-open (Sampath's video, 2026-10-23). CSS adds the row's height back as margin
     under the header while it is folded, so the page never changes height; --tbh-search-h is that
     height. Small finger wobbles (under 6px) are ignored. */
  /* scrollHeight is the row's full content height whatever its max-height is mid-animation (Android
     fires resize as the address bar hides, and offsetHeight then read a few px, leaving the row stuck
     nearly shut). The value only ever grows. */
  var rowH = 0;
  function measure() {
    var h = row.scrollHeight;
    if (h > rowH && h < 200) { rowH = h; head.style.setProperty('--tbh-search-h', rowH + 'px'); }
  }
  measure();
  window.addEventListener('resize', measure, { passive: true });
  /* HYSTERESIS, Sampath 2026-10-26 (second video): short thumb swipes and Chrome's address bar
     showing and hiding still toggled it. Now it folds only after 40px of steady downward travel and
     returns after 40px upward (or near the top), and every fold, unfold or resize (the address bar)
     is followed by 350ms in which nothing toggles. The anchor is where the current direction began. */
  var anchor = last, dir = 0, quietUntil = 0;
  function setOut(out) {
    if (head.classList.contains('tbh-search-out') === out) return;
    head.classList.toggle('tbh-search-out', out);
    quietUntil = Date.now() + 350;
  }
  window.addEventListener('resize', function () { anchor = window.scrollY; quietUntil = Date.now() + 350; }, { passive: true });
  function check() {
    ticking = false;
    var y = window.scrollY;
    if (!MOBILE.matches || document.body.classList.contains('fixed') || row.contains(document.activeElement) || y < 200) {
      setOut(false); anchor = y; dir = 0; last = y; return;
    }
    var d = y > last ? 1 : y < last ? -1 : 0;
    if (d && d !== dir) { dir = d; anchor = last; }
    last = y;
    if (Date.now() < quietUntil) { anchor = y; return; }
    if (dir > 0 && y - anchor > 40) { measure(); setOut(true); anchor = y; }
    else if (dir < 0 && anchor - y > 40) { setOut(false); anchor = y; }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; setTimeout(check, 50); } }, { passive: true });
  row.addEventListener('focusin', function () { head.classList.remove('tbh-search-out'); });
  MOBILE.addEventListener ? MOBILE.addEventListener('change', check) : MOBILE.addListener(check);
})();

/* DELIVERY ESTIMATE / RESTOCK FIELD WORDING: the app block's heading is hidden on the product page
 * (CSS), so each field says what it is for. The sold-out field asks for what it wants (an email
 * address); the grey SOLD OUT and NOTIFY ME buttons give the context (Sampath, 2026-10-24). The
 * widget redraws itself on variant changes, so this re-applies whenever it does. */
(function () {
  function set() {
    document.querySelectorAll('.cc-main-product .tba-edd__input').forEach(function (i) { i.placeholder = 'Enter your pincode'; });
    document.querySelectorAll('.cc-main-product .tba-edd__email').forEach(function (i) {
      if (i.placeholder !== 'Enter your email address') { i.placeholder = 'Enter your email address'; i.setAttribute('aria-label', 'Email address for a restock alert'); }
    });
  }
  set();
  var box = document.querySelector('.cc-main-product .tba-edd');
  if (box && window.MutationObserver) new MutationObserver(set).observe(box, { childList: true, subtree: true });
  document.addEventListener('on:variant:change', function () { setTimeout(set, 250); });
})();

/* DESKTOP MENU ON ONE LINE (Sampath, 2026-10-23). From 769px the theme wrapped the menu onto 2 to 3
 * lines below 1440px. Now:
 *  - only links that open a page directly move into a "More" dropdown when space runs out: the quick
 *    links first (Track order, Our brands, Guides, Bike fit, right to left), then New, then Deals;
 *  - the items that open a dropdown (Shop by rider ... Nutrition) never move ("they are not clickable
 *    directly");
 *  - if those still don't fit, the bar is replaced by a "Menu" button and a side drawer built from the
 *    same menu (the theme's own phone menu is tied to the site-wide 769px breakpoint, which the
 *    product and category layouts also use, so it is not moved).
 * Widths are re-checked on resize. Phones keep the theme's drawer unchanged. */
(function () {
  var content = document.querySelector('.main-menu__content');
  var mainUl = content && content.querySelector('.main-nav');
  if (!mainUl) return;
  var secUl = content.querySelector('.secondary-nav');
  var root = document.documentElement;
  var DESKTOP = window.matchMedia('(min-width: 769px)');
  function label(li) { var a = li.querySelector('a'); return a ? a.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var mainItems = [].slice.call(mainUl.children);
  var secItems = secUl ? [].slice.call(secUl.children).filter(function (li) { return li.querySelector('a.secondary-nav__item'); }) : [];
  function isDropdown(li) { return li.classList.contains('main-nav__item--dropdown'); }
  var leafMain = mainItems.filter(function (li) { return !isDropdown(li); });
  var order = secItems.slice().reverse().concat(leafMain.slice().reverse());

  /* "More" dropdown */
  var host = secUl || mainUl;
  var more = document.createElement('li');
  more.className = 'tbh-more';
  more.hidden = true;
  more.innerHTML = '<button type="button" class="secondary-nav__item tbh-more__btn" aria-expanded="false" aria-controls="tbh-more-list">More' +
    '<svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true" focusable="false"><path d="M2 4.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
    '<ul class="tbh-more__list" id="tbh-more-list" role="list" hidden></ul>';
  host.appendChild(more);
  var btn = more.querySelector('.tbh-more__btn');
  var list = more.querySelector('.tbh-more__list');
  /* The sticky header clips whatever hangs below the menu bar, so the list is placed against the
     screen (position: fixed) under the button, and closes on scroll. */
  function setOpen(open) {
    if (open) {
      var b = btn.getBoundingClientRect();
      list.style.top = Math.round(b.bottom + 6) + 'px';
      list.style.right = Math.max(8, Math.round(window.innerWidth - b.right)) + 'px';
    }
    list.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  window.addEventListener('scroll', function () { if (!list.hidden) setOpen(false); }, { passive: true });
  btn.addEventListener('click', function (e) { e.stopPropagation(); setOpen(list.hidden); });
  more.addEventListener('mouseenter', function () { if (DESKTOP.matches) setOpen(true); });
  more.addEventListener('mouseleave', function () { setOpen(false); });
  document.addEventListener('click', function (e) { if (!more.contains(e.target)) setOpen(false); });
  more.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); btn.focus(); } });

  /* "Menu" button + side drawer, for desktop widths where even the dropdown items don't fit */
  var grid = document.querySelector('store-header .header__grid');
  var burger = document.createElement('button');
  burger.type = 'button';
  burger.className = 'tbh-burger';
  burger.setAttribute('aria-haspopup', 'dialog');
  burger.setAttribute('aria-expanded', 'false');
  burger.setAttribute('aria-label', 'Menu');
  /* same three-line icon as the theme's phone button (copied CSS, own class: the header script picks
     up the first .main-menu__toggle it finds, so that class must stay unique to the theme's button) */
  burger.innerHTML = '<span class="tbh-burger__icon" aria-hidden="true"></span>';
  if (grid) grid.insertBefore(burger, grid.firstChild);
  var drawer = null;
  function buildDrawer() {
    if (typeof HTMLDialogElement === 'undefined') return null;
    var d = document.createElement('dialog');
    d.className = 'tbh-drawer';
    d.setAttribute('aria-label', 'Menu');
    var h = '<div class="tbh-drawer__head"><p class="tbh-drawer__title">Menu</p><button type="button" class="tbh-drawer__close" aria-label="Close menu">&times;</button></div><nav class="tbh-drawer__nav">';
    mainItems.forEach(function (li) {
      var name = label(li);
      if (!isDropdown(li)) {
        var a = li.querySelector('a');
        h += '<a class="tbh-drawer__top" href="' + esc(a ? a.getAttribute('href') : '#') + '">' + esc(name) + '</a>';
        return;
      }
      h += '<details class="tbh-drawer__sec"><summary class="tbh-drawer__top">' + esc(name) + '</summary><div class="tbh-drawer__body">';
      [].slice.call(li.querySelectorAll('.child-nav > li')).forEach(function (c) {
        if (c.classList.contains('md:hidden')) return;
        var head = c.querySelector('a.child-nav__item');
        var subs = [].slice.call(c.querySelectorAll('a.grandchild-nav__item'));
        if (subs.length) {
          var hh = head ? head.getAttribute('href') : '#';
          var ht = head ? head.textContent.replace(/\s+/g, ' ').trim() : '';
          h += '<p class="tbh-drawer__group">' + (hh && hh !== '#' ? '<a href="' + esc(hh) + '">' + esc(ht) + '</a>' : esc(ht)) + '</p><ul role="list">';
          subs.forEach(function (s) { h += '<li><a href="' + esc(s.getAttribute('href')) + '">' + esc(s.textContent.replace(/\s+/g, ' ').trim()) + '</a></li>'; });
          h += '</ul>';
        } else if (head && head.getAttribute('href') && head.getAttribute('href') !== '#') {
          h += '<ul role="list"><li><a href="' + esc(head.getAttribute('href')) + '">' + esc(head.textContent.replace(/\s+/g, ' ').trim()) + '</a></li></ul>';
        }
      });
      h += '</div></details>';
    });
    if (secItems.length) {
      h += '<ul class="tbh-drawer__quick" role="list">';
      secItems.forEach(function (li) { var a = li.querySelector('a'); h += '<li><a href="' + esc(a.getAttribute('href')) + '">' + esc(label(li)) + '</a></li>'; });
      h += '</ul>';
    }
    d.innerHTML = h + '</nav>';
    d.querySelector('.tbh-drawer__close').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () { root.classList.remove('tbh-drawer-open'); burger.setAttribute('aria-expanded', 'false'); });
    document.body.appendChild(d);
    return d;
  }
  burger.addEventListener('click', function () {
    if (!drawer) drawer = buildDrawer();
    if (!drawer) return;
    root.classList.add('tbh-drawer-open');
    burger.setAttribute('aria-expanded', 'true');
    drawer.showModal();
  });

  /* Measured on the links themselves: the container's scrollWidth always reads a few px over
     because of the last item's padding. */
  function shown(li) { return !li.hidden && !li.classList.contains('tbh-nav-off'); }
  function overflowing() {
    var box = content.getBoundingClientRect();
    var right = box.right - parseFloat(getComputedStyle(content).paddingRight || 0);
    var lastMain = null, i;
    for (i = mainItems.length - 1; i >= 0; i--) if (shown(mainItems[i])) { lastMain = mainItems[i]; break; }
    var kids = secUl ? [].slice.call(secUl.children).filter(shown) : [];
    var firstSec = kids[0] || null, lastSec = kids[kids.length - 1] || null;
    /* the theme lets each item's padded box run past the edge, so measure the link or button inside */
    function r(li) { return (li.querySelector('a, button') || li).getBoundingClientRect(); }
    var edge = lastSec || lastMain;
    if (edge && r(edge).right > right + 4) return true;
    if (lastMain && firstSec) return r(firstSec).left - r(lastMain).right < 32;
    return false;
  }
  function fill() {
    var inOrder = mainItems.concat(secItems).filter(function (li) { return li.classList.contains('tbh-nav-off'); });
    var html = '';
    inOrder.forEach(function (li, i) {
      var a = li.querySelector('a'); if (!a) return;
      var util = secItems.indexOf(li) >= 0;
      var prevUtil = i > 0 && secItems.indexOf(inOrder[i - 1]) >= 0;
      html += '<li' + (util && i > 0 && !prevUtil ? ' class="tbh-more__sep"' : '') + '><a href="' + esc(a.getAttribute('href')) + '">' + esc(label(li)) + '</a></li>';
    });
    list.innerHTML = html;
  }
  function layout() {
    order.forEach(function (li) { li.classList.remove('tbh-nav-off'); });
    more.hidden = true; setOpen(false);
    root.classList.remove('tbh-nav-burger');
    root.classList.toggle('tbh-nav-one-line', DESKTOP.matches);
    if (!DESKTOP.matches) { if (drawer && drawer.open) drawer.close(); return; }
    var n = 0;
    while (overflowing() && n < order.length) {
      order[n].classList.add('tbh-nav-off');
      more.hidden = false;
      n++;
    }
    if (overflowing()) {
      order.forEach(function (li) { li.classList.remove('tbh-nav-off'); });
      more.hidden = true;
      root.classList.add('tbh-nav-burger');
      return;
    }
    if (drawer && drawer.open) drawer.close();
    fill();
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(layout, 80); }
  window.addEventListener('resize', soon, { passive: true });
  DESKTOP.addEventListener ? DESKTOP.addEventListener('change', layout) : DESKTOP.addListener(layout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  layout();
})();

/* CATEGORY INTRO "MORE" ON PHONES (Sampath, 2026-10-23: "More button for description is missing").
 * tba-home.css clamps the intro's first paragraph to two lines below 750px; descriptions that carry
 * their own <details> "Read more" open it from there, but single-paragraph ones (e.g. Magene) had no
 * way to open it. Adds a More / Less link only when the text is actually cut off. */
(function () {
  var rte = document.querySelector('.collection-banner .rte');
  var p = rte && rte.querySelector(':scope > p:first-child');
  /* tba-collection-subnav.liquid now folds the whole intro behind its own "Read more" (.tbh-clamp);
     two buttons showed on Cyclo-Computers (Sampath, 2026-10-26), so this one stands down there. */
  if (!p || rte.querySelector('details') || rte.classList.contains('tbh-clamp') || (rte.parentElement && rte.parentElement.querySelector('.tbh-clamp__btn'))) return;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'tbh-intro-more';
  btn.setAttribute('aria-expanded', 'false');
  btn.textContent = 'Read more';   /* the same words as the subnav's own fold (Sampath, 2026-10-26) */
  btn.hidden = true;
  rte.appendChild(btn);
  btn.addEventListener('click', function () {
    var open = rte.classList.toggle('tbh-intro-open');
    btn.textContent = open ? 'Read less' : 'Read more';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  function check() {
    if (rte.classList.contains('tbh-intro-open')) return;
    btn.hidden = !(p.scrollHeight > p.clientHeight + 2);
  }
  check();
  window.addEventListener('resize', function () { clearTimeout(check.t); check.t = setTimeout(check, 120); }, { passive: true });
})();

/* CARD SWATCHES SHOW THE COLOUR'S PHOTO (Sampath, 2026-10-23: "takes a lot of time and in most cases
 * doesn't even load"). The theme swaps the card image to a hidden copy of the colour's photo, but a
 * card only carries copies of the product's first 4 to 7 photos (so about a third of taps did
 * nothing), and those copies are lazy, so the download starts only on tap. Here: when a copy is
 * missing it is built from the swatch's own thumbnail (the same file requested at card size), and
 * the photo starts loading as soon as a finger or pointer touches the swatch. Cards with the theme's
 * image slider are left alone. */
(function () {
  function bigFrom(thumb, w) {
    var u = thumb.getAttribute('src') || '';
    if (!u) return '';
    u = u.replace(/([?&])(crop|width|height)=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/\?&+/, '?').replace(/&&+/g, '&');
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function parts(input) {
    var card = input.closest('product-card');
    if (!card || card.querySelector('product-card-image-slider')) return null;
    var id = input.dataset.mediaId;
    var media = card.querySelector('.card__media');
    if (!id || !media) return null;
    var main = media.querySelector('img.card__main-image');
    return { card: card, id: id, media: media, main: main };
  }
  function ensureImg(input) {
    var x = parts(input);
    if (!x || !x.main) return null;
    var img = x.media.querySelector('img[data-media-id="' + x.id + '"]');
    if (!img) {
      var label = x.card.querySelector('label[for="' + input.id + '"]');
      var thumb = label && label.querySelector('img');
      if (!thumb) return null;
      img = document.createElement('img');
      img.className = x.main.className;
      img.alt = x.main.alt;
      img.setAttribute('data-media-id', x.id);
      if (x.main.getAttribute('width')) img.setAttribute('width', x.main.getAttribute('width'));
      if (x.main.getAttribute('height')) img.setAttribute('height', x.main.getAttribute('height'));
      img.sizes = x.main.getAttribute('sizes') || '50vw';
      img.srcset = [320, 460, 600, 800].map(function (w) { return bigFrom(thumb, w) + ' ' + w + 'w'; }).join(', ');
      img.src = bigFrom(thumb, 460);
      img.decoding = 'async';
      img.hidden = true;
      x.main.parentNode.insertBefore(img, x.main.nextSibling);
    }
    img.loading = 'eager';
    /* a hidden <img> is not fetched by every browser; warm the cache with the size the card will use */
    if (!img.dataset.tbhWarm && img.currentSrc === '' && img.src) { img.dataset.tbhWarm = '1'; var pre = new Image(); pre.decoding = 'async'; pre.sizes = img.sizes; pre.srcset = img.srcset; pre.src = img.src; }
    return { img: img, x: x };
  }
  function warm(e) {
    var label = e.target.closest && e.target.closest('.card__swatches label');
    if (!label) return;
    var input = document.getElementById(label.getAttribute('for'));
    if (input) ensureImg(input);
  }
  document.addEventListener('pointerdown', warm, { passive: true, capture: true });
  document.addEventListener('touchstart', warm, { passive: true, capture: true });
  document.addEventListener('mouseover', warm, { passive: true });
  /* runs after the theme's own handler (it listens on the card; this one on the document) */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.card__swatches .opt-btn')) return;
    var r = ensureImg(input);
    if (!r) return;
    [].slice.call(r.x.media.querySelectorAll('img.card__main-image, img[data-media-id]')).forEach(function (im) {
      if (!im.classList.contains('card__hover-image')) im.hidden = im !== r.img;
    });
  });
})();

/* COLLAPSED DELIVERY ESTIMATE OPENS FROM ANYWHERE ON ITS LINE (Sampath, 2026-10-24: "make the icon and
 * text clickable as well"). The widget redraws itself, so this listens on the document and presses
 * the widget's own toggle button. */
document.addEventListener('click', function (e) {
  var line = e.target.closest && e.target.closest('.tba-edd__compact');
  if (!line) return;
  var out = line.closest('.tba-edd__out');
  var toggle = out && out.querySelector('.tba-edd__toggle');
  if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
});

/* PRODUCT GALLERY ARROWS IN SAFARI (2026-10-25, Sampath: "I had to click twice to load the next
 * image"). The theme moves the gallery with scrollTo({behavior: 'smooth'}) on a list with
 * scroll-snap-type: x mandatory, and WebKit cancels every other such scroll (the previous snap
 * settling wins), so Safari needed two clicks per photo; Chrome was fine. Snapping is switched off
 * for the arrow's or thumbnail's own scroll, in the capture phase so it is off before the theme's
 * handler runs, and back on once the scroll has been still for 150 ms (1.2 s at most). Swiping is
 * untouched. Reproduced and checked in WebKit: 1 2 2 3 3 4 before, 2 3 4 5 6 7 8 after. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('media-gallery .media-ctrl__btn, media-gallery .media-thumbs__btn');
    if (!btn) return;
    var v = btn.closest('media-gallery').querySelector('.media-viewer');
    if (!v) return;
    clearTimeout(v.__tbhSnapMax); clearTimeout(v.__tbhSnapIdle);
    v.style.scrollSnapType = 'none';
    function done() { v.removeEventListener('scroll', still); clearTimeout(v.__tbhSnapIdle); clearTimeout(v.__tbhSnapMax); v.style.scrollSnapType = ''; }
    function still() { clearTimeout(v.__tbhSnapIdle); v.__tbhSnapIdle = setTimeout(done, 150); }
    v.addEventListener('scroll', still, { passive: true });
    v.__tbhSnapIdle = setTimeout(done, 400); /* no scroll at all (first or last photo) */
    v.__tbhSnapMax = setTimeout(done, 1200);
  }, true);
})();

/* PICKUP LINE ALWAYS ONE LINE ON PHONES (Sampath, 2026-10-26). tbh-upgrades.css sets 12.5px and
 * nowrap; when a phone's own text-size setting still makes "Pickup available at The Bike Affair,
 * Hyderabad" wider than its row, step the size down by 0.5px to 11px at the least. The pickup block
 * is filled in after load (and again on a variant change), so new ones are watched for. */
(function () {
  var PHONE = window.matchMedia('(max-width: 768px)');
  function fit(p) {
    if (!PHONE.matches) { p.style.fontSize = ''; return; }
    p.style.fontSize = '';
    var size = parseFloat(getComputedStyle(p).fontSize), row = p.closest('.pickup-status'), guard = 0;
    function over() { var box = row.getBoundingClientRect(), r = p.getBoundingClientRect(); return p.scrollWidth > p.clientWidth + 1 || r.right > box.right + 1; }
    while (over() && size > 11 && guard++ < 10) { size -= 0.5; p.style.fontSize = size + 'px'; }
  }
  function all() { document.querySelectorAll('.cc-main-product .product-info .pickup-status p').forEach(fit); }
  var root = document.querySelector('.cc-main-product .product-info');
  if (!root) return;
  all();
  new MutationObserver(function () { clearTimeout(all.t); all.t = setTimeout(all, 50); }).observe(root, { childList: true, subtree: true });
  window.addEventListener('resize', function () { clearTimeout(all.r); all.r = setTimeout(all, 100); }, { passive: true });
})();
